import "../App.css";
import React from "react";
import Project from "./Project";
// import pic from "../Images/propic1.png";

import conquick from "../Images/ConQuick.png";
import Calc from "../Images/Calc_2.png";
import tictactoe from "../Images/TicTacToe.png";

import cryptolic from "../Images/cryptolic.png";
import github from "../Images/github.png";
import videoland from "../Images/VideoLand.png";

import notes from "../Images/NotesApp(PERN).png";
import surveyForm from "../Images/SurveyForm.png";
import acmeLight from "../Images/AcmeLightBiggest.png";

const Projects = () => {
  return (
    <div className="projects">
      <h1>Projects:</h1>
      <div className="frontendProj">
        <h1>Purely FrontEnd</h1>
        <div className="projCards">
          <Project
            imgSource={conquick}
            title="ConQuick"
            description="This is the landing page of my own startup."
            gitLink={"https://github.com/prudhvi0215/ConQuick/tree/master"}
          />
          <Project
            imgSource={Calc}
            title="Calculator"
            description="This is an advanced calculator project with history saver."
            gitLink={
              "https://github.com/prudhvi0215/Calculator_MileStoneProject"
            }
          />
          <Project
            imgSource={tictactoe}
            title="TicTacToe"
            description="This is best multiplayer game known as tictactoe."
            gitLink={"https://github.com/prudhvi0215/TicTacToe/tree/master"}
          />
        </div>
      </div>

      <div className="frontendProj">
        <h1>API Based Projects</h1>
        <div className="projCards">
          <Project
            imgSource={cryptolic}
            title="Cryptolic"
            description="This is the Web3.0 project where users can transfer the ethereum."
            gitLink={"https://github.com/prudhvi0215/Cryptolic"}
          />
          <Project
            imgSource={github}
            title="Github Users"
            description="This project fetches the github popular user information through API."
            gitLink={
              "https://github.com/prudhvi0215/GithubApiProject/tree/master"
            }
          />
          <Project
            imgSource={videoland}
            title="VideoLand"
            description="This is purely API Based project which fetches the videos from Youtube API."
            gitLink={"https://github.com/prudhvi0215/VideoLand"}
          />
        </div>
      </div>

      <div className="frontendProj">
        <h1>Full Stack Projects</h1>
        <div className="projCards">
          <Project
            imgSource={notes}
            title="NotesApp"
            description="This project is developed using Nest js,React,PostgreSQL(DataBase)."
            gitLink={"https://github.com/prudhvi0215/FullStack_NotesApp"}
          />
          <Project
            imgSource={surveyForm}
            title="Survey Form"
            description="This project is developed using Html,Css,Node js,MongoDB(DataBase)."
            gitLink={"https://github.com/prudhvi0215/surveyForm"}
          />
          <Project
            imgSource={acmeLight}
            title="Acmify"
            description="This project is developed using MERN Stack and includes all kinds of charts."
            gitLink={"https://github.com/prudhvi0215/Acme_Frontend"}
          />
        </div>
      </div>
    </div>
  );
};

export default Projects;
